export const WRITE_COMMENT_MODAL_OPENER_TEST_ID = "write-comment-modal-opener";
